<template>
  <div class="w-full px-4">
    <h1 class="xl">Пользовательское соглашение</h1>
  </div>
</template>

<script>
export default {
  name: 'Terms',
  data () {
    return {
    }
  }
}
</script>